module.exports = __webpack_public_path__ + "static/media/z_DogFoot2.f0a822e9.png";